import React, { useCallback } from 'react';
import { useHistory, withRouter } from 'react-router-dom';
import { SiteConfigManager, useSportsbookState } from '@atlas/core';
import { COMPONENT_TYPES } from '@atlas/routing';

import useTranslate from 'common/I18n/Interpreter';
import MenuSubList from 'components/Pages/Menu/MenuSubList/MenuSubList';

const { SPORT_LIVE } = COMPONENT_TYPES;

const LiveList = () => {
  const t = useTranslate();
  const state = useSportsbookState();
  const { sports, loading } = state;

  const { push: historyPush } = useHistory();
  const sportLivePath = SiteConfigManager.getComponentPath(SPORT_LIVE);

  const onClick = useCallback(
    id => {
      historyPush(`${sportLivePath}/${id}`);
    },
    [historyPush],
  );

  if (!loading && (!sports || sports.length === 0)) {
    return <span className="error">{t('There are no live events right now')}</span>;
  }

  return <MenuSubList list={sports} onClick={onClick} />;
};

export default withRouter(LiveList);
